import User from "../../../apis/User";
import Clusters from "../../../apis/Clusters";
import router from "../../../router";

const state = {
    clusters: [],
    clusterError: ""
};

const getters = {};

const actions = {
    getAllClusters({ commit }) {
        return new Promise((resolve, reject) => {
            Clusters.index()
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("GET_ALL_CLUSTERS", response.data.data[0]);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_CLUSTERS", []);
                        commit("DETECT_CLUSTER_ERROR", error.response);
                    }
                })
        });
    },
    getCluster({ commit }, id) {
        return new Promise((resolve, reject) => {
            Clusters.show(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_CLUSTER", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_CLUSTER_ERROR", error.response);
                    }
                })
        })
    },
    createCluster({ commit }, obj) {
        return new Promise((resolve, reject) => {
            Clusters.store(obj)
                .then((response) => {
                    resolve(response.data.data);

                    return response.data.data;
                })
                .then((response) => {
                    commit("CREATE_CLUSTER", response);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_CLUSTER_ERROR", error.response);
                    }
                })
        })
    },
    updateCluster({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Clusters.update(id, obj)
                .then((response) => {
                    resolve(response.data.data);
                    commit("UPDATE_CLUSTER", obj);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_CLUSTER_ERROR", error.response);
                    }
                })
        })
    },
    removeCluster({ commit }, id) {
        return new Promise((resolve, reject) => {
            Clusters.delete(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("REMOVE_CLUSTER", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_CLUSTER_ERROR", error.response);
                    }
                })
        })
    }
};

const mutations = {
    GET_ALL_CLUSTERS(state, response) {
        state.clusters = response;
    },
    GET_CLUSTER(state, id) {

    },
    CREATE_CLUSTER(state, obj) {
        state.clusters.push(obj);
    },
    UPDATE_ClUSTER(state, obj) {
        let objIndexToUpdate = state.clusters.findIndex(el => el.id === obj.id);
        state.clusters[objIndexToUpdate] = obj;
    },
    REMOVE_CLUSTER(state, id) {
        let objIndexToDelete = state.clusters.findIndex(el => el.id === id);
        state.clusters.splice(objIndexToDelete, 1);
    },
    DETECT_CLUSTER_ERROR(state, error) {
        setTimeout(() => {
            state.clusterError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined) {
            state.clusterError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}